import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@deepguide-ai/ui/dialog'
import { FilePreview } from '@/components/evidence-viewer'
import { getChatAttachmentPresentation } from '../lib/attachment-presentation'

export type ChatAttachmentPreviewFile = {
  url: string
  name: string
  type?: string | null
}

export function ChatAttachmentPreviewDialog({
  file,
  onClose,
}: {
  file: ChatAttachmentPreviewFile | null
  onClose: () => void
}) {
  const presentation = file
    ? getChatAttachmentPresentation(file.type, file.name)
    : null

  return (
    <Dialog open={file !== null} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className='flex h-[85vh] !max-w-[min(1200px,95vw)] flex-col gap-0 overflow-hidden rounded-md border border-dialog p-0 shadow-md'
        closeClassName='top-3.5 right-4'
      >
        <DialogHeader className='min-h-12 justify-center px-4 py-0'>
          <DialogTitle className='truncate pr-8 text-[13px] font-medium text-text-secondary'>
            {file?.name}
          </DialogTitle>
        </DialogHeader>
        <div className='min-h-0 flex-1 p-4'>
          {file && presentation ? (
            <FilePreview
              file={{ url: file.url, filename: file.name }}
              type={presentation.previewType}
            />
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  )
}
